import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalTimeRange, RemoveLocalTimeRangeResult, UpdatedLocalTimeRange } from '../../type/shared';
/** Conflicts arising from modifying on-the-record times. */
export class OnTheRecordTimesConflicts {
    /**
     * @param sealedConflicts Details of updated or deleted sealed times.
     * @param hearingConflicts Details of updated or deleted hearing times.
     */
    constructor(sealedConflicts, hearingConflicts) {
        this.sealedConflicts = sealedConflicts
            ? new RemoveLocalTimeRangeResult(sealedConflicts.deleted.map(LocalTimeRange.fromTimeframe), sealedConflicts.updated.map(x => new UpdatedLocalTimeRange(LocalTimeRange.fromTimeframe(x.before), x.after.map(LocalTimeRange.fromTimeframe))))
            : undefined;
        this.hearingConflicts = hearingConflicts
            ? new RemoveLocalTimeRangeResult(hearingConflicts.deleted.map(LocalTimeRange.fromTimeframe), hearingConflicts.updated.map(x => new UpdatedLocalTimeRange(LocalTimeRange.fromTimeframe(x.before), x.after.map(LocalTimeRange.fromTimeframe))))
            : undefined;
    }
}
__decorate([
    Type(() => RemoveLocalTimeRangeResult),
    __metadata("design:type", Object)
], OnTheRecordTimesConflicts.prototype, "sealedConflicts", void 0);
__decorate([
    Type(() => RemoveLocalTimeRangeResult),
    __metadata("design:type", Object)
], OnTheRecordTimesConflicts.prototype, "hearingConflicts", void 0);
